export const pursuitsPageInitialState = {
  passions: [
    { title: '', detail: '' },
    { title: '', detail: '' },
    { title: '', detail: '' }
  ],
  edit: {} as { [key: number]: boolean }
}

export type PursuitsPageState = typeof pursuitsPageInitialState
